function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgNavOffersChat = function SvgNavOffersChat(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    style: {
      enableBackground: "new 0 0 48 48"
    },
    xmlSpace: "preserve"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M31.8 14.9H18.2c-.5 0-.9.4-.9.9v9.5c0 .5.4.9.9.9h2V30c0 .6.8.9 1.1.4l3.1-4.2h7.3c.5 0 .9-.4.9-.9v-9.5c.1-.5-.3-.9-.8-.9z",
    style: {
      fill: "none",
      stroke: "#666",
      strokeWidth: 1.5,
      strokeMiterlimit: 10
    }
  }));
};
export default SvgNavOffersChat;